export default __webpack_public_path__ + "static/media/rzzg.b99d9eb3.jpg";